import {Box, Loading, Typography} from '@viptech/react-components'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {Camera} from 'src/services/api/endpoints/CameraEndpoint'

type Props = {
  cameras: Camera[]
  isLoading: boolean
  camerasIdsSelected: number[]
  handleAddOrRemoveCam: (id: number) => void
}

function CamerasList(props: Props) {
  const {cameras, isLoading, camerasIdsSelected, handleAddOrRemoveCam} = props
  const {styledTheme} = usePersonalizedThemeByCompany()

  return (
    <Box height='90vh' overflow='auto' paddingRight='8px' display='flex' direction='column' rowGap='5px'>
      {isLoading ? (
        <Box position='absolute' left='120px' width='100%' top='45px'>
          <Loading size='20px' />
        </Box>
      ) : (
        cameras.map((camera) => {
          return (
            <Box
              display='flex'
              border={camerasIdsSelected.includes(camera.id) ? `1px solid ${styledTheme.colors.primary}` : '1px solid #C0C0C0'}
              direction='column'
              borderRadius='8px'
              padding='5px 8px'
              width='100%'
              backgroundColor={camerasIdsSelected.includes(camera.id) ? styledTheme.colors.primary : 'white'}
              style={{boxSizing: 'border-box', cursor: 'pointer'}}
              onClick={() => handleAddOrRemoveCam(camera.id)}
              key={camera.id}>
              <Box display='flex' justifyContent='space-between' columnGap='5px'>
                <Typography
                  variant='span'
                  size='12px'
                  weight={600}
                  color={camerasIdsSelected.includes(camera.id) ? 'white' : styledTheme.colors.text}
                  children={camera.name}
                />
                <Typography
                  variant='span'
                  size='10px'
                  color={camerasIdsSelected.includes(camera.id) ? 'white' : styledTheme.colors.text}
                  children={camera.configuration && camera.configuration?.isOnline ? '🟢' : '🔴'}
                />
              </Box>
              <Typography
                variant='span'
                size='10px'
                color={camerasIdsSelected.includes(camera.id) ? 'white' : styledTheme.colors.text}
                children={`# ${camera.id}`}
              />

              <Typography
                variant='span'
                size='10px'
                color={camerasIdsSelected.includes(camera.id) ? 'white' : styledTheme.colors.text}
                children={`${camera.company?.name} - ${camera.client?.name}`}
              />
            </Box>
          )
        })
      )}
    </Box>
  )
}

export default CamerasList
